<template>
  <div class="root" @keyup.enter="handleSaveClick()">
    <form ref="fuelDispenser" class="reactor-form">
      <custom-input
        required
        inputType="text"
        placeholder="Название"
        labelText="Название"
        v-model="model.name"
        :errorMessage="validator['name']"
        :inputValue="model.name"
        name="name"
      />
      <!-- Технический элемент, нужен для скролла к ошибке, если нет ни одного раздаточного рукава -->
      <button
        id="hoses"
        type="text"
        style="width: 0; height: 0; visibility: hidden; overflow: hidden;"
      />

      <main-text>Раздаточные рукава</main-text>

      <div class="hose-block" :key="index" v-for="(hose, index) in hoses">
        <main-select
          class="hose-block-select"
          label="Вещество в рукаве"
          id="substance-select"
          v-model="hoses[index].substance"
          :options="substancesOptions"
          placeholder="Вещество в рукаве"
          :clearable="false"
          isRequired
          :errorMessage="''"
        />

        <custom-input
          class="hose-block-input"
          required
          inputType="number"
          placeholder="Количество рукавов"
          labelText="Количество рукавов"
          v-model="hoses[index].count"
          :errorMessage="''"
          :inputValue="hoses[index].count"
        />

        <button
          class="remove-hose-button"
          type="button"
          @click.prevent="hoses.splice(index, 1)"
        >
          <img src="../../files/close-icon.svg" alt="close icon" />
        </button>
      </div>

      <!-- Вариант общего сообщения об ошибке под блоком -->
      <p v-if="validator['hoses']" class="error-message">
        {{
          Array.isArray(validator["hoses"])
            ? validator["hoses"][0]
            : validator["hoses"]
        }}
      </p>
      <main-button
        class="add-hose-button"
        @click="hoses.push({ substance: {}, count: 0 })"
        type="button"
        >+ Добавить</main-button
      >

      <custom-input
        required
        inputType="number"
        placeholder="Расход жидкости, м3/час"
        labelText="Расход жидкости, м3/час"
        v-model="model.q"
        :errorMessage="validator['q']"
        :inputValue="model.q"
        name="q"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Температура в аппарате, С"
        labelText="Температура в аппарате, С"
        v-model="model.T"
        :errorMessage="validator['T']"
        :inputValue="model.T"
        name="T"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Внутренний радиус отводящего патрубка"
        labelText="Внутренний радиус отводящего патрубка"
        v-model="model.R"
        :errorMessage="validator['R']"
        :inputValue="model.R"
        name="R"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Длина отводящего патрубка, м"
        labelText="Длина отводящего патрубка, м"
        v-model="model.L"
        :errorMessage="validator['L']"
        :inputValue="model.L"
        name="L"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Время аварийного отключения, с"
        labelText="Время аварийного отключения, с"
        v-model="model.shutdown"
        :errorMessage="validator['shutdown']"
        :inputValue="model.shutdown"
        name="shutdown"
      />

      <main-select
        class="create-form-item"
        label="Система пожаротушения"
        id="extinguish-system"
        v-model="model.extinguish_system"
        :options="extinguishOptions"
        placeholder="Система пожаротушения"
        :clearable="false"
        isRequired
        :errorMessage="validator['extinguish_system']"
        :searchable="false"
      />

      <main-select
        class="create-form-item"
        label="Система сигнализации"
        id="alarm-system"
        v-model="model.alarm_system"
        :options="alarmOptions"
        placeholder="Система пожаротушения"
        :clearable="false"
        isRequired
        :errorMessage="validator['alarm_system']"
        :searchable="false"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Коэффициент разлития"
        labelText="Коэффициент разлития"
        v-model="model.f"
        :errorMessage="validator['f']"
        :inputValue="model.f"
        :tooltipValue="spillageCoefficient"
        name="f"
      />
    </form>
    <div class="form-button-block">
      <main-button
        :loading="saving"
        class="form-button"
        @click="handleSaveClick()"
      >
        <span v-if="installation && installation.id">Сохранить</span>
        <span v-else>Создать</span>
      </main-button>

      <main-button @click="onCancelClick" color="link">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import "vue-form-generator/dist/vfg.css";
import Input from "../ui/Input.vue";
import MainButton from "../ui/MainButton.vue";
import MainSelect from "../ui/MainSelect.vue";
import MainText from "../ui/Text.vue";
import {
  EXTINGUISH_OPTIONS,
  SPILLAGE_COEFFICIENT,
} from "../../constants/constants";
import { scrollToErrorInput } from "../../utils/utils.js";

export default {
  components: {
    "custom-input": Input,
    MainSelect,
    MainButton,
    MainText,
  },
  props: {
    saving: Boolean,
    installation: Object,
    proj_id: Number,
    substances: Array,
    substance: Object,
    type: {
      validator: function (value) {
        return [21].indexOf(value) !== -1;
      },
    },
    validator: Object,
    loadSubstances: Function,
  },
  methods: {
    onCancelClick() {
      this.$bvModal.hide("addInstallation");
    },

    validate() {
      this.$emit("update:validator", {});
      const errors = {};
      let isValid = true;

      const elementNames = Array.from(this.$refs.fuelDispenser.elements)
        .map((element) => element.name)
        .filter((item) => Boolean(item));

      elementNames.forEach((item) => {
        if (
          this.model[item] !== 0 &&
          this.model[item] !== "0" &&
          !this.model[item]
        ) {
          isValid = false;
          errors[item] = "Необходимо заполнить поле";
        }
      });
      if (this.hoses.length == 0) {
        isValid = false;
        errors["hoses"] = "Необходимо заполнить 'Раздаточные рукава'";
      }
      scrollToErrorInput(errors, this.$refs.fuelDispenser);
      this.$emit("update:validator", errors);
      return isValid;
    },

    handleSaveClick() {
      if (this.validate()) {
        this.$emit("create", {
          ...this.model,
          hoses: this.hoses.map((hose) => {
            return {
              substance: Number(hose.substance.code),
              count: hose.count,
            };
          }),
        });
      }
    },
  },
  watch: {
    type: function (val) {
      this.$set(this.model, "obj_type", val);
    },
    installation() {
      Object.assign(this.model, this.installation);
    },
    substance() {
      this.model.substance = {
        code: this.substance.id,
        label: this.substance.name,
      };
    },
    substances() {
      this.substancesOptions = this.substances[0].subs.map((item) => {
        return { code: item.id, label: item.name };
      });

      // Данные по рукавам при редактировании
      if ("hoses" in this.installation && this.substances[0]) {
        this.hoses = this.installation.hoses.map((item) => {
          const currentSubstance = this.substances[0].subs.find((sub) => {
            return item.substance == sub.id;
          });

          return {
            substance: {
              code: currentSubstance.id,
              label: currentSubstance.name,
            },
            count: item.count,
          };
        });
      }
    },
    validator() {
      this.$set(this.model, "validator", this.validator);
    },
  },
  mounted() {
    this.$set(this.model, "obj_type", this.type);

    this.loadSubstances(2);

    if (this.installation.id) {
      Object.assign(this.model, this.installation);
      this.model.extinguish_system = this.extinguishOptions.find(
        (item) => item.code === Number(this.installation.extinguish_system)
      );
      this.model.alarm_system = this.alarmOptions.find(
        (item) => item.code === Number(this.installation.alarm_system)
      );
    }
  },
  data() {
    return {
      hoses: [],
      substancesOptions: [],
      extinguishOptions: EXTINGUISH_OPTIONS,
      alarmOptions: [
        { code: 0, label: "Отсутствует" },
        { code: 0.8, label: "Присутствует" },
      ],
      spillageCoefficient: SPILLAGE_COEFFICIENT,

      model: {
        name: "ТРК (ЛВЖ и ГЖ)",
        obj_type: 21,
        substance: null,
        R: 0.01,
        T: 37,
        q: 4.8,
        L: 4,
        shutdown: 120,
        f: 150,
        validator: {},
        hoses: [],
        extinguish_system: { code: 0, label: "Отсутствует" },
        alarm_system: { code: 0, label: "Отсутствует" },
      },
    };
  },
};
</script>

<style scoped>
.root {
  position: relative;
  padding: 0;
}
.reactor-form {
  padding: 0 24px 32px;
}
.create-form-item {
  margin-bottom: 16px;
}

.hose-block {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 16px;
}

.hose-block-select {
  min-width: 400px;
  width: 400px;
}
.hose-block-input {
  width: 200px;
  margin-bottom: 0;
}

.remove-hose-button {
  border: none;
  padding: 0;
  background: transparent;
  position: absolute;
  right: 16px;
  top: 8px;
}
.add-hose-button {
  margin-bottom: 16px;
}
.error-message {
  color: var(--error-color);
}
</style>
